<ng-container [formGroup]="formGroupCampaignTypeData">
    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Send Ticket with QR Code" formControlName="sendTickets" id="sendTickets"></app-mdb-switch>
      <div class="d-flex align-items-center ml-2 h-100">
        <app-text-popover
          placement="right"
          type="content"
          text="Turn it on if you want to send a ticket along with the payment confirmation. This is useful if guests need to be checked in at the venue."
          title=""
        >
        </app-text-popover>
      </div>
    </div>
    <div class="divider"></div>

    <div>
      <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Enforce ticket inventory for this ticket campaign" formControlName="enforceCampaignInventory"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="To control the number of tickets sold across all ticket options in this campaign, switch this ON. For eg., if you are selling tables and individual tickets but your venue allows 200 guests, you would switch this ON and enter 200 as the inventory count."
            title=""
          >
          </app-text-popover>
        </div>
      </div>
      <div style="padding-left: 44px;" class="mb-4" *ngIf="formGroupCampaignTypeData.value.enforceCampaignInventory">
        <mdb-form-control class="form-fill mb-0" >
          <app-mdbp-input mdbInput formControlName="campaignInventory" [isCurrencyMask]="true"  label='Ticket Inventory Count'>
              <input  #inputNameC currencyMask formControlName="campaignInventory" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
              <mdb-error class="form-fill-error ml-0" style="margin-top: 2px;" *ngIf="formGroupCampaignTypeData.controls.campaignInventory.hasError('min') && formGroupCampaignTypeData.controls.campaignInventory.touched">Please provide Global Total Inventory bigger than 0</mdb-error>
              <mdb-error class="form-fill-error ml-0" style="margin-top: 2px;" *ngIf="formGroupCampaignTypeData.controls.campaignInventory.hasError('incorrect') && formGroupCampaignTypeData.controls.campaignInventory.touched">Please provide Global Total Inventory bigger than Sold</mdb-error>
          </app-mdbp-input>
        </mdb-form-control>
        <div class="d-flex group-ticket-info__container px-2 py-1" style="width: fit-content;font-size: 12px; padding-left: 14px!important;"[ngStyle]="{'margin-top': isTolalInventoryValid?'10px':'20px'}">
          <div class="group-ticket-info__icon mr-2 d-flex align-items-center">
              <img src="img/svg/quickpay/group-ticket.svg" height="15" width="15">
          </div>
          <div class="group-ticket-info__content" style="font-weight: 400;">
              {{getSold()}}
          </div>
        </div>

        <div class="d-flex align-items-center">
          <app-mdb-switch label="Hide ticket inventory for this ticket campaign" formControlName="hideCampaignInventory"></app-mdb-switch>
          <div class="ml-2 h-100">
              <app-text-popover
                  placement="right"
                  type="content"
                  text="Tooltip for flag: To control the number of tickets sold in this campaign but hide the number of remaining tickets left, switch this ON."
                  title=""
              >
              </app-text-popover>
          </div>
      </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Allow for multiple type selection" formControlName="multiSelect"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="When turned on, guests can pick more than one option. This is useful when guests need to pick a few options like tickets and meals or do transactions at a food stall."
            title=""
          >
          </app-text-popover>
        </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Collect guest information per ticket" formControlName="guestRequired" id="guestRequired"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="Use this to collect information like meal preferences, phone numbers, and addresses for each guest."
            title=""
          >
          </app-text-popover>
        </div>
    </div>
    <div style="padding-left: 44px;" class="mb-4" *ngIf="formGroupCampaignTypeData.value.guestRequired">
      <div class="d-flex align-items-center">
        <app-mdb-switch label="Disable guest entry before payment" formControlName="noGuestRequiredBeforePayment"></app-mdb-switch>
        <div class="ml-2 h-100">
            <app-text-popover
                placement="right"
                type="content"
                text="By default, ticket holders can add their guest information before payment if they know who's attending or after payment if they're unsure. If you don't want to accept guest information before payment, switch this ON."
                title=""
            >
            </app-text-popover>
        </div>
      </div>
    </div>
    <div style="padding-left: 44px;" class="mb-4" *ngIf="formGroupCampaignTypeData.value.guestRequired">
      <div class="body-1 mb-2">Date set here controls cut off time for guest entry.</div>
        <app-datetime
          dateLabel="End Date"
          timeLabel="End Time"
          formControlName="guestAddCuttoffDate"
          [myDatePickerOptions]="guestCutOffEndTimeOptions"
          [submitted]="campaignFormService.submitted"
          data-panel="settings"
      ></app-datetime>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper" *ngIf="formGroupCampaignTypeData.controls.guestRequired.value">
        <app-mdb-switch label="Save Card Enabled" formControlName="saveCardEnabled"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="Switching this ON will add a 'Save Card' button to the ticket reminder emails allowing donors to save a card on file. Only available when ticket campaign is connected to an in-person event."
            title=""
          >
          </app-text-popover>
        </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Send Checkin Email Notification" formControlName="sendCheckinEmail" id="sendCheckinEmail"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="If switched ON, guests will receive an email notification upon check-in with Table and Paddle number.."
            title=""
          >
          </app-text-popover>
        </div>
    </div>
    <div style="padding-left: 44px;" class="mb-4" *ngIf="formGroupCampaignTypeData.value.sendCheckinEmail">
      <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Send Checkin Text Notification" formControlName="sendCheckinText" id="sendCheckinText"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="If on, guests will receive text notification along with email upon check-in with Table and Paddle number if a phone number is available."
            title=""
          >
          </app-text-popover>
        </div>
      </div>
    </div>
    <div class="divider"></div>

    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
      <app-mdb-switch label="Display Current Ticket Holders to Buyers" formControlName="showTicketHolders" id="showTicketHolders"></app-mdb-switch>
      <div class="d-flex align-items-center ml-2 h-100">
        <app-text-popover
          placement="right"
          type="content"
          text="If switched ON, the list of ticket holders will be displayed to all ticket purchasers."
          title=""
        >
        </app-text-popover>
      </div>
  </div>
  <div class="divider"></div>

  <div class="d-flex align-items-center mat-slide-toggle__wrapper">
    <app-mdb-switch label="Enable Grid View On Donor Side" formControlName="gridView" id="gridView"></app-mdb-switch>
    <div class="d-flex align-items-center ml-2 h-100">
      @if(formGroupCampaignTypeData.controls.gridView.value){
        <i class="fas fa-th mr-2"></i>
      }@else{
        <i class="fas fa-bars mr-2"></i>
      }
      <app-text-popover
        placement="right"
        type="content"
        text="The ticket options are displayed as a list on the donor side by default. To enable grid view, switch this flag ON."
        title=""
       >
    </app-text-popover>
    </div>
  </div>
  <div class="divider"></div>

  <div class="d-flex align-items-center mat-slide-toggle__wrapper">
    <app-mdb-switch label="Make tickets private/invitation-only" formControlName="privateTicket" id="privateTicket"></app-mdb-switch>
    <div class="d-flex align-items-center ml-2 h-100">
      <app-text-popover
        placement="right"
        type="content"
        text="If switched ON, only invitees can view and purchase/register for these tickets. You’ll be able to manage access and send invitations via Manage > Tickets & Guests > Invitations."
        title=""
      >
      </app-text-popover>
    </div>
  </div>
  <div class="divider"></div>

</ng-container>